import {envBackHost} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import {useEffect, useState} from 'react'
import {globalFormatWithHyphens, recognizedTypeHandler} from 'utils/const/globalConst'
import {confirmAlert, resultAlert} from 'utils/CustomAlert/Alert'

interface photoInfoComponentP {
  section: string
  headTitle: string
  list: any
  fixable?: boolean
  initData?: Record<string, string>
  optionsMap?: Record<string, {label: string; value: string}[]>
  originalData?: Record<any, any>
  reCall?: any
}

export const PhotoInfoCardComponent = ({
  section,
  headTitle,
  list,
  fixable = false,
  initData = {},
  optionsMap = {},
  originalData = {},
  reCall,
}: photoInfoComponentP) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const [isFix, setIsFix] = useState<boolean>(false)
  const [shareInitData, setShareInitData] = useState(initData)
  const [editData, setEditData] = useState(initData)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  /**
   * 설치 정보 (외함, 외표기) 수정
   */
  const updateInstallInfo = async () => {
    let updateData = {
      customerNumber: editData?.customerNumber,
      officeId: editData?.officeId,
      customerTypeId: editData?.customerTypeId,
      customerWorkTypeId: editData?.customerWorkTypeId,
      addressRoad: editData?.addressRoad,
      addressNumber: editData?.addressNumber,
      addressDetail: editData?.addressDetail,
      phoneNumber: editData?.phoneNumber,
      managerName: editData?.managerName,
      managerPhoneNumber: editData?.managerPhoneNumber,
      meterManufacturer: editData?.meterManufacturer,
      meterNumber: editData?.meterNumber,
      meterDiameter: editData?.meterDiameter,
      checkMonth: editData?.checkMonth,
      checkDay: editData?.checkDay,
      memo: editData?.memo,
      customerName: editData?.customerName,
      isOuterCaseInstalled: editData?.isOuterCaseInstalled,
      outerCaseSizeType: editData?.outerCaseSizeType,
      isExternalDisplayInstalled: editData?.isExternalDisplayInstalled,
    }
    if (await confirmAlert('수정', 'info')) {
      axiosWithAuth()
        .put(`${envBackHost}/customerinfo`, {...updateData, filter2: editData?.managerPhoneNumber})
        .then(async (res) => {
          if (res.data.resultCode === 0) {
            reCall()
            setShareInitData(updateData)
            setEditData(updateData)
            setIsFix(false)
            return await resultAlert(res.data)
          }
        })
        .catch(async (e) => {
          await resultAlert({resultCode: e.response.status})
        })
    } else {
      return
    }
  }

  const isFixCancle = () => {
    setEditData(shareInitData)
    setIsFix(false)
  }

  const isFixHandler = async () => {
    if (!isFix) {
      setIsFix(true)
    } else {
      await updateInstallInfo()
    }
  }

  const selectHandler = (
    e: React.ChangeEvent<HTMLSelectElement>,
    field: string,
    section: string
  ) => {
    let raw = e.target.value
    let value: string | boolean | number | null = raw
    if (raw === 'true') value = true
    if (raw === 'false') value = false
    if (raw === 'null') value = null

    setEditData((prev: any) => {
      if (section === 'extraSetting' && field === 'isOuterCaseInstalled' && value === false) {
        return {
          ...prev,
          isOuterCaseInstalled: false,
          outerCaseSizeType: '-',
        }
      }

      return {
        ...prev,
        [field]: value,
      }
    })
  }

  /**
   *  select의 label 표기 + 그냥 input인 경우는 value 표기
   * @param id
   * @param maps
   * @param list
   * @param value
   * @returns
   */
  const inputViewHandler = (id: any, maps: any, list: any, value: any) => {
    switch (id) {
      case 'customer':
        if (list.id === 'customerNumber') {
          return globalFormatWithHyphens(shareInitData.officeId, value)
        }
        return value

      case 'extraSetting':
        const options = maps[list.id] || []
        const match = options.find((opt: any) => String(opt.value) === String(value))
        return match?.label ?? '-'

      case 'meter':
        if (list.id === 'meterDiameter') {
          if (value === '') {
            return '-'
          }
          return `${value}mm`
        }

        if (list.id === 'recognizedType') {
          return recognizedTypeHandler(value)
        }
        return value

      case 'check':
        if (list.id === 'checkDay') {
          return `${value}일`
        }
        return value

      default:
        return value
    }
  }

  const renderEditField = (
    section: string,
    id: string,
    value: any,
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  ) => {
    switch (section) {
      case 'extraSetting':
        return (
          <select
            className='w-2/3 px-4 py-2 text-[1.25rem] border rounded font-semibold'
            value={value}
            onChange={onChange}
            onKeyDown={(e) => e.stopPropagation()}
          >
            {optionsMap[id]?.map((opt) => (
              <option key={opt.value} value={String(opt.value)}>
                {opt.label}
              </option>
            ))}
          </select>
        )
      case 'customer':
        return (
          <input
            className={`w-2/3 px-4 py-2 border rounded font-semibold text-[1.25rem] ${
              id === 'customerNumber' ? 'bg-slate-300' : ''
            }`}
            type='text'
            value={
              id === 'customerNumber'
                ? globalFormatWithHyphens(shareInitData.officeId, value)
                : value
            }
            disabled={id === 'customerNumber' ? true : false}
            onChange={(e) => onChange(e as any)}
            onKeyDown={(e) => e.stopPropagation()}
          />
        )

      case 'meter':
        return (
          <input
            className={`w-2/3 px-4 py-2 border rounded font-semibold text-[1.25rem] ${
              id === 'customerNumber' ? 'bg-slate-300' : ''
            }`}
            type='text'
            value={value ?? ''}
            disabled={id === 'customerNumber' ? true : false}
            onChange={(e) => onChange(e as any)}
            onKeyDown={(e) => e.stopPropagation()}
          />
        )

      case 'check':
        if (id === 'checkMonth') {
          return (
            <select
              className='w-2/3 px-4 py-2 text-[1.25rem] border rounded font-semibold'
              value={String(value ?? '')}
              onChange={onChange}
              onKeyDown={(e) => e.stopPropagation()}
            >
              <option key='now' value={'당월'}>
                당월
              </option>
              <option key='before' value={'전월'}>
                전월
              </option>
            </select>
          )
        } else {
          return (
            <input
              className={`w-2/3 px-4 py-2 border rounded font-semibold text-[1.25rem] ${
                id === 'customerNumber' ? 'bg-slate-300' : ''
              }`}
              type='text'
              value={value ?? ''}
              disabled={id === 'customerNumber' ? true : false}
              onChange={(e) => onChange(e as any)}
              onKeyDown={(e) => e.stopPropagation()}
            />
          )
        }

      default:
        return (
          <input
            className='w-2/3 px-4 py-2 border rounded font-semibold text-[1.25rem]'
            type='text'
            value={value ?? ''}
            onChange={(e) => onChange(e as any)}
          />
        )
    }
  }

  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/
  useEffect(() => {
    setShareInitData(originalData)
    setEditData(originalData)
    setIsFix(false)
  }, [originalData])

  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/

  return (
    <div className='p-4 rounded-lg bg-white mb-2' id={section}>
      <div className='flex justify-between'>
        <span className='font-semibold text-[1.5rem]'>{headTitle}</span>
        {fixable && (
          <div className='flex gap-2'>
            {isFix && (
              <button
                className='flex items-center gap-1 border border-blue-500 text-red-500 hover:bg-blue-50 font-medium px-4 py-1 rounded-lg text-[1rem] transition'
                onClick={() => {
                  isFixCancle()
                }}
              >
                수정 취소
              </button>
            )}
            <button
              className='flex items-center gap-1 border border-blue-500 text-blue-500 hover:bg-blue-50 font-medium px-4 py-1 rounded-lg text-[1rem] transition'
              onClick={() => {
                isFixHandler()
              }}
            >
              {isFix ? '수정 완료' : '수정'}
            </button>
          </div>
        )}
      </div>
      <div className='bg-white mt-2'>
        {list.map((listItem: any, idx: any) => {
          const raw = shareInitData[listItem.id] ?? listItem.value
          const content = inputViewHandler(section, optionsMap, listItem, String(raw)) || '-'
          return (
            <div key={idx} className='flex border-b last:border-none group'>
              <div className='bg-gray-100 w-1/3 px-4 font-medium text-[1.25rem] text-gray-700 flex items-center'>
                {listItem.label}
              </div>

              {!isFix ? (
                <div
                  className={`
                    text-[1.25rem] font-semibold text-ellipsis
            w-2/3 px-4 py-2
            overflow-hidden whitespace-nowrap
            group-hover:whitespace-normal
            group-hover:break-words
            group-hover:overflow-visible
            transition-all duration-100
          `}
                >
                  {content}
                </div>
              ) : (
                renderEditField(section, listItem.id, editData[listItem.id], (e) => {
                  e.stopPropagation()
                  selectHandler(e, listItem.id, section)
                })
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
